const card = {
   namespaced: true,
    state: {
      
    },
     mutations: { 
      
     },
  actions: { 

  },
  getters: { 

   }
}
export default card